import React from 'react'
import { useIntl } from 'react-intl';
import Hero from '../../components/Hero';
import TelecomLinkBoxRow from '../../components/TelecomLinkBoxRow';

export type IFT_017_2023Props = {};

const IFT_017_2023: React.FC<IFT_017_2023Props> = () => {
  const intl = useIntl();
  return (
    <div className="w-full flex flex-col">
      <Hero
        bgImage={'/img/telecom-header-planet.png'} 
        heading={intl.formatMessage({
          id: "telecommunications",
          defaultMessage: "Telecommunications"
        })}
        subHeading='IFT-017-2023'
      />
      <TelecomLinkBoxRow />
      <div className="content !px-4 md:!px-2 lg:!px-0 !py-16">
        <div className="flex w-full flex-col items-start justify-center">
          <div className="flex flex-col w-full pt-0 md:pt-6 pb-10 md:pb-0 gap-10 pr-10 max-w-[950px]">
            <div className="">
              <h2 className='text-xl text-secondary font-bold mb-2'>
                IFT-017-2023
              </h2>
              <p>
                {
                  intl.formatMessage({
                    id: "ift_017_2023_title",
                    defaultMessage: "Radio communication equipment that uses digital modulation and operates in the 5150 MHz-5250 MHz, 5250 MHz-5350 MHz, 5470 MHz-5600 MHz, 5650 MHz-5725 MHz, 5725 MHz-5850 MHz, and 5925 MHz-6425 MHz bands."
                  })
                }
              </p>
            </div>
            <div>
              <h2 className='text-xl text-secondary font-bold uppercase mb-2'>
                {
                  intl.formatMessage({
                    id: 'scope',
                    defaultMessage: "Scope:"
                  })
                }
              </h2>
              <p>
                {
                  intl.formatMessage({
                    id: "ift_017_2023_scope",
                    defaultMessage: "It applies to all products, equipment, devices, or apparatus, or where applicable, product prototypes intended for telecommunications that can be connected to a telecommunications network and that use the radio spectrum for radiocommunication systems that employ digital modulation techniques, use wireless access, in local area radio networks, and that operate in any of the bands classified as unlicensed spectrum: 5150 MHz–5250 MHz, 5250 MHz–5350 MHz, 5470 MHz–5600 MHz, 5650 MHz–5725 MHz, 5725 MHz–5850 MHz, and 5925 MHz–6425 MHz, or all of them together."
                  })
                }
              </p>
            </div>
          </div>
          <div className="w-full mt-12 flex justify-center">
            <img className="max-w-md w-full" src="/img/ift-017-image.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default IFT_017_2023;